export default __webpack_public_path__ + "static/media/gallery_03.76b165c0.jpg";